import React, {Fragment, useEffect} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {useModelFormEngine} from "../common/hooks/useModelFormEngine";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {PillButton} from "../common/PillButton";
import {Constants} from "../common/Constants";

import _ from "lodash";
import Select from 'react-select';
import {SelectUtility} from "../common/SelectUtility";

export const FpServicesForm = function (props) {
    function getInitialModelState(extFpServices) {
        let showExpenseAccountField = false;
        let fpServiceType = _.find(props.fpServiceTypes, function (fpServiceType) {
            return '' + props.fpServiceTypeId === '' + fpServiceType.id
        })
        let initialFpServicesState = []
        for (let i = 0; i < extFpServices.length; i++) {
            let extFpService = extFpServices[i];
            let fpService = extFpService.fp_service || {}
            let fpServiceState = {
                id: fpService && fpService.id,
                ext_fp_service_id: extFpService.id,
                name: extFpService.name,
                ext_qbo_income_account_id: fpService.ext_qbo_income_account_id,
                ext_qbo_expense_account_id: null
            }

            if (fpServiceType.name === Constants.fpServiceTypeNames.externalExpense) {
                showExpenseAccountField = true
                if (fpService && fpService.ext_qbo_expense_account_id) {
                    fpServiceState.ext_qbo_expense_account_id = fpService.ext_qbo_expense_account_id
                }
            }

            initialFpServicesState.push(fpServiceState)
        }

        return {
            showExpenseAccountField: showExpenseAccountField,
            fpServices: initialFpServicesState
        };
    }

    let initialModelState = getInitialModelState(props.fpServices)

    const fetchSupportingData = function () {
        return ApiUtility.getQboAccountsList()
            .then(function (qboAccounts) {
                return Promise.resolve({
                    supportingData: {
                        qboAccountOptions: SelectUtility.modelArrayToSelectOptions(qboAccounts)
                    }
                });
            })
    }

    const formEngine = useModelFormEngine(
        initialModelState,
        null,
        fetchSupportingData,
        validateForm,
        formStateToSaveData,
        props.save
    );

    useEffect(() => {
        formEngine.renderableData.updateAndRender(getInitialModelState(props.fpServices))
    }, [props.fpServiceTypeId]);

    function validateForm(handleValidationResult) {
        return new Promise(function (resolve, reject) {
            let validationErrors = [];
            let invalidFields = [];

            Promise.resolve({})
                .then(function () {
                    return handleValidationResult(validationErrors, invalidFields, resolve);
                });
        });
    }

    function formStateToSaveData(formStateToTransform) {
        let saveData = _.clone(formStateToTransform);
        saveData.fp_service_type_id = props.fpServiceTypeId;
        saveData.supportingData = null;

        let fpServicesMinimal = [];
        for (let x = 0; x < saveData.fpServices.length; x++) {
            let fpService = saveData.fpServices[x]
            let fpServiceMinimal = {
                id: fpService.id,
                ext_fp_service_id: fpService.ext_fp_service_id,
            }
            if (fpService.ext_qbo_income_account_id) {
                fpServiceMinimal.ext_qbo_income_account_id = fpService.ext_qbo_income_account_id;
            }
            if (fpService.ext_qbo_expense_account_id) {
                fpServiceMinimal.ext_qbo_expense_account_id = fpService.ext_qbo_expense_account_id;
            }

            fpServicesMinimal.push(fpServiceMinimal)
        }
        saveData.fpServices = fpServicesMinimal

        return saveData;
    }

    function handleQboAccountChange(fieldName, option, index) {
        let fpServicesUpdate = _.clone(formEngine.renderableData.fpServices);
        fpServicesUpdate[index][fieldName] = option.value
        formEngine.updateAndRenderUnsavedData({fpServices: fpServicesUpdate});
    }

    return (
        <Fragment>
            <ConditionalRenderer
                if={formEngine.renderableData.showOverlayLoadingIndicator || !formEngine.renderableData.supportingData}
                renderer={() => (
                    <div className="sub-form-loading-indicator-container">
                        <OverlayLoadingIndicator/>
                    </div>
                )}
            />
            <ConditionalRenderer if={formEngine.renderableData.supportingData} renderer={() => {
                const showExpenseAccountField = formEngine.renderableData.showExpenseAccountField;
                let showExpenseAccountFieldFormClass = showExpenseAccountField ? 'with-expense-field' : ''
                let fpServicesDisplay = [];
                for (let v = 0; v < formEngine.renderableData.fpServices.length; v++) {
                    let fpService = formEngine.renderableData.fpServices[v]
                    fpServicesDisplay.push(
                        <FpServiceFormRow
                            key={v}
                            index={v + 1}
                            fpService={fpService}
                            showExpenseAccountField={showExpenseAccountField}
                            qboAccountOptions={formEngine.renderableData.supportingData.qboAccountOptions}
                            handleQboAccountChange={
                                (fieldName, option) => handleQboAccountChange(fieldName, option, v)
                            }
                            getFormFieldClasses={formEngine.getFormFieldClasses}
                        />
                    )
                }
                let headerCellsDisplay = [
                    <div key={0} className="common-form-list-row-cell fp-service-name">FP service</div>,
                    <div key={1} className="common-form-list-row-cell qbo-income-account">QBO income account</div>
                ]
                if (showExpenseAccountField) {
                    headerCellsDisplay.push(
                        <div key={2} className="common-form-list-row-cell qbo-expense-account">QBO expense account</div>
                    )
                }
                return (
                    <div className={`common-form fp-services-form ${showExpenseAccountFieldFormClass}`}>
                        <div className="common-form-body">
                            <div className="common-form-list">
                                <div className="common-form-list-header">
                                    <div className="common-form-list-header-content">
                                        {headerCellsDisplay}
                                    </div>
                                </div>
                                <div className="common-form-list-body">
                                    {fpServicesDisplay}
                                </div>
                            </div>

                            <div className="common-form-body-row">
                                <div className="common-form-options">
                                    <PillButton
                                        onClick={formEngine.onClickSave}
                                        containerClasses="common-form-button-container"
                                        buttonClasses="common-form-button save-button"
                                        buttonText={"SAVE"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}/>
        </Fragment>
    );
}

let FpServiceFormRow = (props) => {
    return (
        <div className={`common-form-list-row fp-service-row-${props.index}`}>
            <div className="common-form-list-row-content">
                <div className="common-form-list-row-cell fp-service-name">
                    {props.fpService.name}
                </div>

                <div
                    className={props.getFormFieldClasses(
                        "common-form-list-row-cell qbo-income-account",
                        "ext_qbo_income_account_id"
                    )}
                >
                    <Select
                        className="common-form-select qbo-account-select"
                        classNamePrefix="common-form-select"
                        value={SelectUtility.selectOptionForId(
                            props.fpService.ext_qbo_income_account_id,
                            props.qboAccountOptions
                        )}
                        onChange={(option) => props.handleQboAccountChange(
                            'ext_qbo_income_account_id',
                            option
                        )}
                        options={props.qboAccountOptions}
                    />
                </div>

                <ConditionalRenderer
                    if={props.showExpenseAccountField}
                    renderer={() => (
                        <div
                            className={props.getFormFieldClasses(
                                "common-form-list-row-cell qbo-expense-account",
                                "ext_qbo_expense_account_id"
                            )}
                        >
                            <Select
                                className="common-form-select qbo-account-select"
                                classNamePrefix="common-form-select"
                                value={SelectUtility.selectOptionForId(
                                    props.fpService.ext_qbo_expense_account_id,
                                    props.qboAccountOptions
                                )}
                                onChange={(option) => props.handleQboAccountChange(
                                    'ext_qbo_expense_account_id',
                                    option
                                )}
                                options={props.qboAccountOptions}
                            />
                        </div>
                    )}
                />
            </div>
        </div>
    )
}
